import { FC } from "react";
import { Box, Typography } from "@mui/material";
import ModalBoxCore from "../../../core-components/modal-box/ModalBoxCore";
import ModalHeader from "../../../core-components/modal-box/modal-header/ModalHeader";
import ModalBody from "../../../core-components/modal-box/modal-body/ModalBody";
import ExclamationInCircle from "../../../../assets/svg-fc/ExclamationInCircle";
import palette from "../../../../theme/palette";
import "./previewModal.scss";

interface IPreviewModalProps {
	open: boolean;
	onClose: () => void;
	htmlContent: string;
	title?: string;
}

const PreviewModal: FC<IPreviewModalProps> = ({ open, onClose, htmlContent, title = "Preview" }) => {
	return (
		<ModalBoxCore open={open} onClose={onClose} className="previewModal">
			<ModalHeader modalHeaderText={title} closeModal={onClose} />
			<ModalBody className="previewModalBody">
				{/* Warning Banner */}
				{title && (
					<Box className="previewWarning">
						<ExclamationInCircle size="24" color={palette.error.main} />
						<Typography variant="body2" className="warningText">
							Preview only. Submit the form to generate the official quote.
						</Typography>
					</Box>
				)}
				{/* Preview Content */}
				<Box className="previewContent" dangerouslySetInnerHTML={{ __html: htmlContent }} />
			</ModalBody>
		</ModalBoxCore>
	);
};

export default PreviewModal;
